import { createStyles, rem } from "@mantine/core"
import type { ModalProps } from "@mantine/core"

export const useStyles = createStyles((theme, { maxWidth }: { maxWidth: ModalProps["size"] }) => ({
    modalContent: {
        maxWidth: rem(maxWidth),
        borderRadius: "20px",
    },

    modalHeader: {
        width: "100%",
        height: rem(40),
        alignItems: "center",
        display: "flex",
        padding: "8px 10px 8px 12px",
    },

    modalTitle: {
        color: theme.colors.gray[8],
        fontWeight: 500,
        fontSize: rem(16),
        textAlign: "center",
        justifyContent: "center",
        padding: `${rem(8)} 0`,
    },

    modalBody: {
        display: "flex",
        borderTop: `1px solid ${theme.colors.gray[2]}`,
        borderBottom: `1px solid ${theme.colors.gray[2]}`,
        alignItems: "center",
        justifyContent: "center",
        padding: `${rem(20)} ${rem(12)}`,
        flex: 1,
    },

    modalButtons: {
        alignItems: "center",
        justifyContent: "center",
        padding: `${rem(12)} 0`,
        gap: "0.75rem",
    },
    actionButton: {
        padding: `${rem(8)} ${rem(12)}`,
        height: "2rem",
        fontSize: "0.875rem",
        borderRadius: "20px",
        width: "fit-content",
    },
}))
